"use client";
import type { ISiteSettings, IEntry } from "@contentful-api/types/contentful";
import { DefaultLayout } from "@app/DefaultLayout";
import { ProductListingPage } from "templates/ProductListingPage";
import PageContent from "../PageContent";
import { PageTypes } from "@lib/enums/PageTypes";
import type { MicrocopySet } from "@lib/contentful/microcopy/types";
import type { Module } from "@lib/contentful/modules-renderer/ModuleType";
import type { InitialResults } from "instantsearch.js";
import { ProductCategoryPage } from "templates/ProductCategoryPage";

interface CategoryPageBaseProps {
    initialFiltersList?: Record<string, any>;
    isPreview: boolean;
    pageType: PageTypes;
    siteSettings: ISiteSettings;
    sharedMicrocopySet: MicrocopySet;
    pageMicrocopySet: MicrocopySet;
    page: Module | IEntry;
    pageTestId?: string;
    algoliaFallbackState: InitialResults;
}

export default function CategoryPageBase({
    isPreview,
    pageType,
    siteSettings,
    sharedMicrocopySet,
    pageMicrocopySet,
    page,
    initialFiltersList,
    pageTestId,
    algoliaFallbackState,
}: CategoryPageBaseProps) {
    const isPLP = pageType === PageTypes.PLP;

    return (
        <PageContent
            isPreview={isPreview}
            pageType={pageType}
            siteSettings={siteSettings}
            sharedMicrocopySet={sharedMicrocopySet}
            pageMicrocopySet={pageMicrocopySet}
        >
            <DefaultLayout siteSettings={siteSettings} chatButtonPersist={!isPLP}>
                {isPLP ? (
                    <>
                        <div hidden aria-hidden="true" data-testid={pageTestId} />
                        <ProductListingPage
                            siteSettings={siteSettings}
                            page={page}
                            isMenPage={false}
                            initialFiltersList={initialFiltersList}
                            algoliaFallbackState={algoliaFallbackState}
                        />
                    </>
                ) : (
                    <ProductCategoryPage siteSettings={siteSettings} page={page} />
                )}
            </DefaultLayout>
        </PageContent>
    );
}
